module.exports = __webpack_public_path__ + "img/M_map_2.8f24b055.png";